module.exports = __webpack_public_path__ + "fonts/9def975.TTF";